const config = {
  hasuraUrl: process.env.VUE_APP_HASURA,
  baseURL: process.env.VUE_APP_API_URL,
  vuexStorageKeys: [
    'token',
    'originToken',
    'devMode',
    'changelog'
  ],
  initPlugins: [
    'init',
    'vuexStorage',
    'userInit',
    'routeAuth'
  ]
}
export default config
